<template>
  <button @click="toggle" :class="{ on: localToggle }">
    <span></span>
  </button>
</template>

<script>
import { ref, watch } from "vue";

export default {
  name: "toggleBtnVue",
  props: {
    target: {
      type: [Boolean, Number],
      default: false
    }
  },
  emits: ["update"],
  setup(props, { emit }) {
    const localToggle = ref(props.target);

    watch(() => props.target, (val) => {
      localToggle.value = val;
    });

    const toggle = () => {
      localToggle.value = !localToggle.value;
      emit("update", localToggle.value);
    };

    return { localToggle, toggle };
  }
};
</script>


<style scoped>
  button {
    width:48px;
    height:24px;
    border-radius: 100px;
    padding:4px;
    gap:6px;
    display: flex;
    align-items: start;
    justify-content: end;
    border:none;
    box-sizing: border-box;
    cursor:pointer;
  }

  button > span {
    width:16px;
    height:16px;
    border-radius: 100px;
    background-color: var(--color-text-primary);
  }

  button.on {
    background-color: var(--color-special-point);
    justify-content: start;
  }
</style>